import validate from "/app/node_modules/.pnpm/nuxt@3.11.2_@types+node@20.2.4_@unocss+reset@0.59.4_axios@1.4.0_eslint@8.41.0_floating-vue@5._ilrzprycdi33lgvqv64su5jo2i/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.11.2_@types+node@20.2.4_@unocss+reset@0.59.4_axios@1.4.0_eslint@8.41.0_floating-vue@5._ilrzprycdi33lgvqv64su5jo2i/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/app/middleware/auth.ts")
}